import { configureStore } from "@reduxjs/toolkit";
import dictionarySlice from "./dictionary/dictionary-slice";
import householdSlice from "./household/household-slice";
import userSlice from "./user/user-slice";
import systemSlice from "./system/system-slice";
import uqSlice from "./uq/uq-slice";
import stockSlice from "./stock/stock-slice";
import stockPriceRegisterSlice from "./stock-price-register/stock-price-register-slice";
import npvSlice from "./npv/npv-slice";
import balanceSheetSlice from "./balance-sheet/balance-sheet-slice";

const store = configureStore({
  reducer: {
    dictionary: dictionarySlice.reducer,
    household: householdSlice.reducer,
    system: systemSlice.reducer,
    user: userSlice.reducer,
    uq: uqSlice.reducer,
    stock: stockSlice.reducer,
    stockPriceRegister: stockPriceRegisterSlice.reducer,
    npv: npvSlice.reducer,
    balanceSheet: balanceSheetSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
